import { List, SimpleGrid } from '@chakra-ui/react';

import PostCardItemOutline from '@/components/Card/PostItemCardOutline';

import RoutePath from '@/constants/route-path';
import { NewsArticlesProps, OpportunitieQuicklookProps } from '@/models/props/NewsArticleProps';

function NewsGrid(props: Pick<NewsArticlesProps, 'data'>) {
    const { data } = props;

    return (
        <SimpleGrid as={List} rowGap={3}>
            {data.map((item, index) => (
                <PostCardItemOutline
                    key={index}
                    title={item.attributes.title}
                    shortDescription={item.attributes.shortDescription || ''}
                    url={`${RoutePath.News}/${item.attributes.slug}` || ''}
                    imageUrl={
                        (item.attributes.image?.data as OpportunitieQuicklookProps)?.attributes
                            .formats?.medium?.url === undefined
                            ? (item.attributes.image?.data as OpportunitieQuicklookProps)
                                  ?.attributes.url
                            : (item.attributes.image?.data as OpportunitieQuicklookProps)
                                  ?.attributes.formats?.medium?.url
                    }
                    imageAlt={
                        (item.attributes.image?.data as OpportunitieQuicklookProps)?.attributes
                            .alternativeText || item.attributes.title
                    }
                />
            ))}
        </SimpleGrid>
    );
}

export default NewsGrid;
